import React, { FC } from 'react'

import { IconBraceletNotFoundProps } from './IconBraceletNotFound.types'
import * as Styled from './styles/IconBraceletNotFound.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBraceletNotFound: FC<IconBraceletNotFoundProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBraceletNotFoundProps['size'],
  isResponsive = false,
}: IconBraceletNotFoundProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M28.793 43h-9.585a1.5 1.5 0 0 1-1.458-1.175L16 34.053v-19.98l1.75-7.838a1.5 1.5 0 0 1 1.453-1.175H29a1.5 1.5 0 0 1 1.473 1.213l1.527 7.8v19.98l-1.75 7.772A1.5 1.5 0 0 1 28.793 43Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M30.495 13.072h-12.99a1.5 1.5 0 0 0-1.5 1.5v18.98a1.5 1.5 0 0 0 1.5 1.5h12.99a1.5 1.5 0 0 0 1.5-1.5v-18.98a1.5 1.5 0 0 0-1.5-1.5Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M42 6 6 42' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBraceletNotFound
